import { connect, getIn } from 'formik';
import PropTypes from 'prop-types';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';

import { numberWithLessDecimals } from 'hb-react/shared/utils/formatNumber';
import { validateMaximumNumberOfDecimals } from 'hb-react/shared/utils/validators/maximumNumberOfDecimals';
import { validateMinimum } from 'hb-react/shared/utils/validators/minimum';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

const AmountError = ({ formik, minimumAmount = 0, currency }) => {
  const id = 'other_amount';
  const amountValue = getIn(formik.values, 'donation_order[amount]');
  const amountIsTouched =
    getIn(formik.touched, 'donation_order[amount]') || formik.submitCount > 0;

  if (!amountIsTouched) {
    return null;
  }

  if (validateRequired(amountValue)) {
    return (
      <span data-testid="required-amount-error">
        <AdditionalInformation type="error" id={id}>
          {__('The amount is required')}
        </AdditionalInformation>
      </span>
    );
  }

  if (validateMinimum(amountValue, minimumAmount)) {
    const minimumError = __('The minimum gift allowed is %{minimum}').i__({
      minimum: `${currency.symbol} ${numberWithLessDecimals(minimumAmount)}`,
    });

    return (
      <span data-testid="minimal-amount-error">
        <AdditionalInformation type="error" id={id}>
          {minimumError}
        </AdditionalInformation>
      </span>
    );
  }

  if (validateMaximumNumberOfDecimals(amountValue, 2)) {
    return (
      <span data-testid="maximum-decimals-error">
        <AdditionalInformation type="error" id={id}>
          {validateMaximumNumberOfDecimals(amountValue, 2)}
        </AdditionalInformation>
      </span>
    );
  }

  return null;
};

AmountError.propTypes = {
  currency: PropTypes.object.isRequired,
  minimumAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default connect(AmountError);
